import { formatDateForInventory } from '@/utils/helpers'

interface ExpirationDateBadgeProps {
  expirationDate?: string
}

export function ExpirationDateBadge({
  expirationDate,
}: ExpirationDateBadgeProps) {
  if (!expirationDate) {
    return (
      <div className="flex w-full flex-col items-start text-left">
        <span className="text-gray-400">-</span>
      </div>
    )
  }

  const today = new Date()
  const expiry = new Date(expirationDate)
  const diffTime = expiry.getTime() - today.getTime()
  const daysUntilExpiry = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

  // Definir colores según los días restantes
  let badgeStyles = ''

  if (daysUntilExpiry <= 7) {
    // Próximo a vencerse (7 días o menos) - Rojo: text-red-800 (#991B1B), bg-red-100 (#FECACA)
    badgeStyles = 'text-red-800'
  } else if (daysUntilExpiry <= 30) {
    // Alerta (8-30 días) - Amarillo: text-yellow-800 (#713F12), bg-yellow-100 (#FEF9C3)
    badgeStyles = 'text-yellow-800'
  } else {
    // Seguro (más de 30 días) - Verde: text-green-800 (#166534), bg-green-100 (#BBF7D0)
    badgeStyles = 'text-green-800'
  }

  const bgStyles =
    daysUntilExpiry <= 7
      ? 'bg-red-100'
      : daysUntilExpiry <= 30
        ? 'bg-yellow-100'
        : 'bg-green-100'

  return (
    <div className="flex w-full flex-col items-start text-left">
      <div
        className={`inline-flex rounded-full px-2 py-1 text-xs font-medium ${bgStyles} ${badgeStyles}`}
      >
        <span className="block">{formatDateForInventory(expirationDate)}</span>
      </div>
    </div>
  )
}
